import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex text-gray-800 align-items-center" }
const _hoisted_2 = { class: "ml-3" }
const _hoisted_3 = {
  key: 0,
  class: "section"
}
const _hoisted_4 = { class: "name-grid" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "section"
}
const _hoisted_7 = { class: "name-grid" }

import { ref, toRefs, watch, computed } from 'vue';
import { EMIT } from '@/enum';

interface ReferralInterface {
  id: number;
  service_provider_id: number | null;
  index: number;
  student_name: string;
  page: number;
}

interface PropsInterface {
  referrals: ReferralInterface[];
  open: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserApproveReferral',
  props: {
    referrals: {},
    open: { type: Boolean }
  },
  emits: [EMIT.CANCEL, EMIT.SAVE, 'update-referrals'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { referrals, open } = toRefs(props);

const referralsArray = ref<ReferralInterface[]>([...referrals.value]);

watch(referrals, (newReferrals) => {
  referralsArray.value = [...newReferrals];
});

// Computed properties to filter users
const usersWithServiceProvider = computed(() =>
  referralsArray.value.filter((referral) => referral.service_provider_id !== null),
);

const usersWithoutServiceProvider = computed(() =>
  referralsArray.value.filter((referral) => referral.service_provider_id === null),
);

const onCancel = () => emit(EMIT.CANCEL);

const onApprove = () => emit(EMIT.SAVE);

const onDelete = (index: number, listType: 'with' | 'without') => {
  if (listType === 'with') {
    const referral = usersWithServiceProvider.value[index];
    const referralIndex = referralsArray.value.findIndex((r) => r.id === referral.id);
    referralsArray.value.splice(referralIndex, 1);
  } else {
    const referral = usersWithoutServiceProvider.value[index];
    const referralIndex = referralsArray.value.findIndex((r) => r.id === referral.id);
    referralsArray.value.splice(referralIndex, 1);
  }
  emit('update-referrals', referralsArray.value);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(open))
      ? (_openBlock(), _createBlock(_component_ConfirmAction, {
          key: 0,
          header: "Approve Referral",
          "accept-label": "Approve",
          onAccept: onApprove,
          onCancel: onCancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Icon, {
                name: "warning",
                class: "confirm-dialog-icon text-primary-800"
              }),
              _createElementVNode("span", _hoisted_2, [
                _cache[2] || (_cache[2] = _createTextVNode(" Are you sure you want to approve the following referrals? ", -1)),
                (usersWithServiceProvider.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersWithServiceProvider.value, (referral, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: referral.id,
                            class: "name-item"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(referral.student_name), 1),
                            _createElementVNode("button", {
                              class: "delete-button ml-1",
                              onClick: ($event: any) => (onDelete(index, 'with'))
                            }, [...(_cache[0] || (_cache[0] = [
                              _createElementVNode("span", { class: "material-icons text-red-600" }, "highlight_off", -1)
                            ]))], 8, _hoisted_5)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (usersWithoutServiceProvider.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[1] || (_cache[1] = _createElementVNode("p", null, "These referrals require a Service Provider to be approved.", -1)),
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersWithoutServiceProvider.value, (referral) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: referral.id,
                            class: "name-item"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(referral.student_name) + " (Page " + _toDisplayString(referral.page) + ")", 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})